import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  removeFromFilter,
  updateFilter,
} from "../../../store/slices/filterSlice";

const WhiteColor = () => {
  const whileShade = ["D", "E", "F", "G", "H", "I", "J", "K", "L", "M"];
  const dispatch = useDispatch();
  const filterSelect = useSelector((state) => state?.filter);
  const handleAddFilter = (value) => {
    dispatch(updateFilter({ key: "color", value: value }));
  };
  const handleRemoveFilter = (value) => {
    dispatch(removeFromFilter({ key: "color", value: value }));
  };

  return (
    <div className="white-color-shade filter-bg-container range-outer-container">
      {whileShade?.map((item) => {
        return (
          <div
            className={`shade-color-item range-item ${
              filterSelect?.color?.includes(item) ? "active" : ""
            }`}
            onClick={() =>
              filterSelect?.color?.includes(item)
                ? handleRemoveFilter(item)
                : handleAddFilter(item)
            }
          >
            {item}
          </div>
        );
      })}
    </div>
  );
};

export default WhiteColor;
